<mat-form-field>
  <mat-select
    #matSelect
    [placeholder]="matPlaceholder"
    [formControl]="sdpControl"
    [required]="isRequired"
    [(ngModel)]="value"
    (selectionChange)="selectionChange.emit($event)"
    [multiple]="isMultiple"
  >
    <mat-option *ngIf="hasSelectOption">{{ defaultOptionText }}</mat-option>
    <mat-option *ngFor="let item of referenceTypeList" [value]="item.id">
      {{ item.name }}
    </mat-option>
  </mat-select>
  <mat-error> <sd-validation-messages [control]="sdpControl"> </sd-validation-messages> </mat-error>
</mat-form-field>
